export { default } from './leasing-info';
